import IsEmpty from "./helpers/IsEmpty"
import SwalToast from "./helpers/SwalToast"
import axios from "axios";
import Cookie from "js-cookie";
import React from 'react'

// dataType
export const dataTypeOptions = [
    { value: 'purchase', label: 'Pembelian' },
    { value: 'birth', label: 'Kelahiran' },
    { value: 'archive', label: 'Archive' }
]
// sourceOfPurchase
export const sourceOfPurchaseOptions = [
    { value: 'import', label: 'Import' },
    { value: 'non_import', label: 'Non Import' }
]

// gender
export const genderOptions = [
    { value: 'male', label: 'Male', code: 'M' },
    { value: 'female', label: 'Female', code: 'F' }
]
export const getGender = (gender) => {
    for (let i = 0; i < genderOptions.length; i++) {
        if (genderOptions[i].value === gender) return genderOptions[i].label
    }
    return gender
}

//goatStatus
export const goatStatusOptions = [
    { value: 'fertile', label: 'Subur' },
    { value: 'infertile', label: 'Tidak Subur' },
    { value: 'goatling', label: 'Anak Kambing' },
    { value: 'pregnant', label: 'Bunting' },
    { value: 'laktasi', label: 'Laktasi' },
    { value: 'sold', label: 'Terjual' },
]
export const getGoatStatus = (status) => {
    for (let i = 0; i < goatStatusOptions.length; i++) {
        if (goatStatusOptions[i].value === status) return goatStatusOptions[i].label
    }
    return status
}

//goatHealth
export const goatHealthOptions = [
    { value: 'alive', label: 'Sehat' },
    { value: 'dead', label: 'Mati' },
    { value: 'sick', label: 'Sakit' },
    { value: 'pending_dead', label: 'Konfirmasi Kematian' },
]
export const getGoatHealth = (goatHealth) => {
    for (let i = 0; i < goatHealthOptions.length; i++) {
        if (goatHealthOptions[i].value === goatHealth) return goatHealthOptions[i].label
    }
    return goatHealth
}

// name type
export const nameTypeOptions = [
    { value: 'fullblood', label: 'Fullblood (Automatic)' },
    { value: 'crossboer', label: 'Cross Boer (Automatic)' },
    { value: 'manual', label: 'Manual' },
]

// age
export const ageOptions = [
    { value: 'lt3m', label: '<3 Bulan', lower: null, upper: 3 },
    { value: '3-6m', label: '3-6 Bulan', lower: 3, upper: 6 },
    { value: '6-12m', label: '6-12 Bulan', lower: 6, upper: 12 },
    { value: '1-2y', label: '1-2 Tahun', lower: 1 * 12, upper: 2 * 12 },
    { value: '2-3y', label: '2-3 Tahun', lower: 2 * 12, upper: 3 * 12 },
    { value: 'gt3y', label: '>3 Tahun', lower: 3 * 12, upper: null },
]

// download function
export const downloadGoatCertificate = (filename) => {
    axios.get(encodeURI(`${process.env.REACT_APP_BASE_API_URL}kambing/certificate/download/${filename}`), {
        headers: {
            Authorization: 'Bearer ' + Cookie.get('token'),
        },
        responseType: "blob",
    }).then(response => {
        const url = URL.createObjectURL(response.data);
        const link = document.createElement('a');
        link.href = url;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        link.remove();
    }).catch(error => {
        console.log(error)
        if (IsEmpty(error.response)) {
            SwalToast.fire({
                icon: 'error',
                title: 'Whoops, something went wrong!'
            });
        } else {
            console.log(error)
            if (error.response) {
                var reader = new FileReader();
                reader.onload = function () {
                    let returnJson = JSON.parse(reader.result)
                    SwalToast.fire({
                        icon: 'error',
                        title: returnJson.message
                    });
                }
                reader.readAsText(error.response.data);
            }
        }
    });
}
export const downloadGallery = async (filename) => {
    if (!filename) return

    let url = encodeURI(`${process.env.REACT_APP_BASE_API_URL}kambing/view/downloadGallery/${filename}`)
    return await axios.get(url, {
        headers: {
            Authorization: 'Bearer ' + Cookie.get('token'),
        },
        responseType: "blob",
    }).then(response => {
        return URL.createObjectURL(response.data)
    }).catch(error => {
        console.log(error)
        if (error.response) {
            var reader = new FileReader();
            reader.onload = function () {
                let returnJson = JSON.parse(reader.result)
                console.log(returnJson)
            }
            reader.readAsText(error.response.data);
        }
    });
}

export const ShowGoatName = (goat, uppercase = false) => {
    if (!goat) return "";

    const getName = () => {
        let full_name = goat.full_name
        if (uppercase) full_name = full_name.toUpperCase()
        return full_name
    }
    return (<>
        {getName()}
        {goat.data_type == "archive" && <span className="ml-1"><i title="Archive" className="fas fa-archive color-a49368" /></span>}
    </>)
}

export const ShowFamilyName = (family_name) => {
    if (!family_name) return "";

    return (<>
        {family_name.name}
        {IsFamilyNameAutoGenerated(family_name) && <span className={`ml-1`}><i title="Crossboer" className='fa fa-crosshairs color-FFB200' /></span>}
    </>)
}

export const IsFamilyNameAutoGenerated = (family_name) => {
    if (!family_name) return "";

    if (family_name.male_family_name_id || family_name.female_family_name_id) {
        return true
    }
    return false
}